import type { FaireProductEntity } from "../../entity_types/product";

export const tomato_list: FaireProductEntity = {
  token: "tomato-list",
  type: "product",
  name: "Tomato-do List",
  brandName: "State The Label",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/d43dcc7728200ede1ab8091ddb6892679895c784560376785908165e6232b9d9.webp",
  priceDollars: 75,
  msrpDollars: 150,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_proto_home-and-living"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
